export default "__VITE_ASSET__CXPA0eLm__"